<template>
    <rkm-overlay>
        <rkm-layout-body title="Nova internação">
            <template v-slot:actions>
                <rkm-button
                    color="primary"
                    @click="redirectToForm"
                >
                    Paciente desconhecido
                </rkm-button>

                <rkm-button
                    v-if="isPermissaoCadastro"
                    color="primary"
                    @click.stop="showQuestion"
                >
                    Novo paciente
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List>
                    <template #actions="{ item }">
                        <rkm-button
                            color="primary"
                            class="align-self-end"
                            @click="handleInternar(item)"
                        >
                            Internar
                        </rkm-button>
                    </template>
                </List>
            </rkm-layout-content>
        </rkm-layout-body>

        <ModalPacienteCadastroSimplificado
            ref="ModalPacienteCadastroSimplificado"
            @save="redirectToForm"
        />
    </rkm-overlay>
</template>

<script>
import List from '@/components/cadastro/paciente/components/busca/List'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'

import { repository, request, data } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { List, ModalPacienteCadastroSimplificado },
    created() {

        this.repositories = {
            aih: this.getConectaSusRepository('prontoAtendimento.aih'),
            dataHora: this.getConectaSusRepository('dataHora'),
        }

        this.load()
    },
    data: () => ({
        isPermissaoCadastro: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.aih.list()
                .then(({ data }) =>

                    this.isPermissaoCadastro = data.classificacoes.length > 0 || data.isPermissaoCadastro
                        ? true
                        : false
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        showQuestion() {

            this.showConfirmation('O paciente apresentou os documentos?',
                async () => this.$refs.ModalPacienteCadastroSimplificado.open(),
                async () => {

                    this.fetch(this.repositories.dataHora.get)
                        .then(({ data }) => this.$refs.ModalPacienteCadastroSimplificado
                            .openWithoutDocuments(this.getDateTimeObject(data)))
                }
            )
        },
        handleInternar(paciente) {

            this.fetch(this.repositories.aih.index, { finalizada: false, paciente_id: paciente.id })
                .then(({ data }) => {

                    if (data.length > 0) {

                        this.showWarningNotification('Paciente já está internado. Finalize o atendimento para '
                            + 'iniciar um novo.')

                        return
                    }

                    this.redirectToForm(paciente)
                })
        },
        redirectToForm(paciente) {

            const params = {}

            if (paciente) {

                params.pacienteId = paciente.id
            }

            this.$router.push({ name: 'pronto-atendimento-aih-create', params })
        },
    },
    mixins: [repository, request, data],
}
</script>